'use strict';

document.addEventListener('DOMContentLoaded', () => {
  //.frontPagePlanArticleTitle を取得する
  const frontPagePlanArticleTitle = document.querySelectorAll(
    '.frontPagePlanArticleTitle'
  ) as NodeListOf<HTMLElement>;

  // frontPagePlanArticleTitleの各々の要素のlengthのうち一つでも17以上の場合は、高さを43pxにする
  frontPagePlanArticleTitle.forEach((title) => {
    if (title.textContent!.length >= 17) {
      title.style.height = '43px';
    }
  });
});
